import React from "react";
import { Link } from "react-router-dom";
import { AppData } from "../types/app";
import SiteLayout from "./layout/SiteLayout";
import AppIcon from "./AppIcon";
import "../styles/docs.css";

export type AppDocTab = "about" | "privacy" | "terms" | "support" | "delete-account";

export interface AppDocTabsProps {
  app: AppData;
  current: AppDocTab;
}

const TABS: { id: AppDocTab; label: string }[] = [
  { id: "about", label: "소개" },
  { id: "privacy", label: "개인정보처리방침" },
  { id: "terms", label: "이용약관" },
  { id: "support", label: "고객지원" },
  { id: "delete-account", label: "계정 삭제" },
];

export default function AppDocTabs({ app, current }: AppDocTabsProps) {
  const tabs = TABS.filter((t) => t.id !== "delete-account" || app.has_account);
  const navRef = React.useRef<HTMLElement>(null);

  // 폰 폭에서 탭 줄이 가로로 스크롤되면 현재 탭이 화면 밖에 남는다. 페이지 세로 위치는 건드리지 않는다.
  React.useEffect(() => {
    const nav = navRef.current;
    const tab = nav?.querySelector('[aria-current="page"]');
    if (!nav || !tab) return;
    const over = tab.getBoundingClientRect().right - nav.getBoundingClientRect().right;
    if (over > 0) nav.scrollLeft += over;
  }, [current]);

  return (
    <div className="docs-tabbar">
      {/* 소개 탭은 상세 화면이 큰 머리를 따로 그리므로 미니 머리를 숨긴다 (HfAppDetail) */}
      {current !== "about" && (
        <div className="docs-minihead">
          <AppIcon app={app} className="docs-icon--md" />
          <div className="docs-minihead-text">
            <strong>{app.name}</strong>
            <span className="docs-mono docs-muted">apps / {app.slug}</span>
          </div>
        </div>
      )}
      <nav ref={navRef} aria-label="앱 문서" className="docs-tabs">
        {tabs.map((t) => (
          <Link
            key={t.id}
            to={t.id === "about" ? `/apps/${app.slug}` : `/apps/${app.slug}/${t.id}`}
            className="docs-tab"
            aria-current={t.id === current ? "page" : undefined}
          >
            {t.label}
          </Link>
        ))}
      </nav>
    </div>
  );
}

export function AppNotFound({ slug }: { slug: string }) {
  React.useEffect(() => {
    document.title = "앱을 찾을 수 없습니다 | kwangbok.me";
  }, []);
  return (
    <SiteLayout crumb={`apps / ${slug}`}>
      <div className="docs docs-card docs-pad">
        <h1 className="docs-h1">앱을 찾을 수 없습니다</h1>
        <p className="docs-muted">주소가 바뀌었거나 없는 앱입니다.</p>
        <p>
          <Link to="/apps" className="docs-link">
            앱 목록으로 가기
          </Link>
        </p>
      </div>
    </SiteLayout>
  );
}
